export const BILLING_TABS = [
    {
      value: "",
      label: "Payments Due",
    },
    {
      value: "paymentsMade",
      label: "Payments History",
    }, 
    {
      value: "savedCards",
      label: "Saved Cards",
    }, 
  ];